import React from 'react';
import { Link } from "react-router-dom";
import { BsCaretDown } from 'react-icons/bs';

const NavDemo = () => {
    return (
        <ul className="mainmenu">
            <li className="has-droupdown">
                <Link to="/" className="d-flex align-items-center justify-content-between w-100">
                    <span className='pr-2'>Home </span>
                    <BsCaretDown className='mt-2' />
                </Link>
                <ul className="submenu">
                    <li><Link to="/about-us">About</Link></li>
                    <li><Link to="/contact">Contact</Link></li>
                    <li><Link to="/media">Media</Link></li>
                </ul>
            </li>

            <li className=""><Link to="/training">Training</Link></li>
            <li className=""><Link to="/consulting">Consulting</Link></li>
            <li className=""><Link to="/speaking">Speaking</Link></li>
            <li className=""><Link to="/course">Course</Link></li>
            {/* <li className=""><Link to="/content">Content</Link></li> */}
            {/* <li className="has-droupdown">
                <Link to="/content" className="d-flex align-items-center justify-content-between w-100">
                    <span className='pr-2'>Content </span>
                    <BsCaretDown className='mt-2'/>
                </Link>
                
                
            </li> */}
            {/* <li className="with-megamenu"><Link to="/content" className="d-flex align-items-center justify-content-between w-100">
                    <span className='pr-2'>Content </span>
                    <BsCaretDown className='mt-2' />
                </Link>
                <div className="rn-megamenu">
                    <div className="wrapper">
                        <div className="row row--0">
                            <div className="col-lg-3 single-mega-item">
                                <ul className="mega-menu-item">
                                    <li><Link to="#">Mindset</Link></li>
                                    <li><Link to="#">Wealth</Link></li>
                                    <li><Link to="#">Health</Link></li>
                                    <li><Link to="#">Relationship</Link></li>
                                    <li><Link to="#">Business</Link></li>
                                    <li><Link to="#">Leadership</Link></li>
                                    <li><Link to="#">Happiness</Link></li>
                                </ul>
                            </div>
                            <div className="col-lg-3 single-mega-item">
                                <ul className="mega-menu-item">
                                    <li><Link to="#">NewsLeter</Link></li>
                                    <li><Link to="#">Documentory</Link></li>
                                    <li><Link to="#">Blog</Link></li>
                                    <li><Link to="#">Podcast</Link></li>
                                    <li><Link to="#">Free Resources</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </li> */}
            <li className="has-droupdown">
                <Link to="/content" className="d-flex align-items-center justify-content-between w-100">
                    <span className='pr-2'>Content </span>
                    <BsCaretDown className='mt-2 ml-3' />
                </Link>
                <ul className="submenu">
                    <li><Link to="#">Psychological Health</Link></li>
                    <li><Link to="#">Physical Health</Link></li>
                    <li><Link to="#">Emotional Health</Link></li>
                    <li><Link to="#">Financial Health</Link></li>
                    <li><Link to="#">Spiritual Health</Link></li>
                </ul>
            </li>

            <li className=""><Link to="/community">Community</Link> </li>
            <li><Link to="/affiliate">Affiliate</Link></li>
            <li className=""><Link to="/podcast">Podcast</Link> </li>




        </ul>
    )
}
export default NavDemo;
